'use client'

import dynamic from 'next/dynamic'

import '@/components/Top/TopCampaignSection/TopCampaignSlide/TopCampaignSlide.scss'
import { CampaignPageType } from '@/types/campaignPage'

const TopCampaignSliderLogic = dynamic(
  () => import('@/components/Top/TopCampaignSection/TopCampaignSlide/TopCampaignSliderLogic'),
  {
    ssr: true,
  }
)

const TopCampaignSlide = ({ pages }: { pages: CampaignPageType[] }) => {
  return <TopCampaignSliderLogic pages={pages} />
}

export default TopCampaignSlide
